( function($) {
  if (LoopOnstore.isActive()) {
    var body = $("body");
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        var attributeValue = $(mutation.target).prop(mutation.attributeName);
        if (attributeValue.includes('rebuy-cart-visible')) { // Side cart opened
          var onstoreSideCheckoutBtn = $("<button id=\"onstore-checkout-btn\" class=\"rebuy-button block\">Check out</button>");
          $('[data-rebuy-component="checkout-area"]').empty();
          $('[data-rebuy-component="checkout-area"]').prepend(onstoreSideCheckoutBtn);
        }
      });
    });
    
    observer.observe(body[0], {
      attributes: true,
      attributeFilter: ['class']
    });
  
    if ($('#CartPageForm').length) { // Main Cart
      // Replace with Onstore Checkout Btn
      var onstoreCheckoutBtn = $("<button id=\"onstore-checkout-btn\" class=\"btn btn--no-animatecss\">Check out</button>");
      onstoreCheckoutBtn.css('width', '100%');
      $('.cart__checkout-wrapper').append(onstoreCheckoutBtn);
      
      
  
      // Remove default checkout btn
      $('.cart__checkout').remove();
    }
  }
} (jQuery)); 
